<template>
    <select v-model="selected_data">
        <slot></slot>
        <option v-for="item in data" :value="item.id">
            {{ item.name }}
        </option>
    </select>
</template>

<script>
export default {
    name: "SelectData",
    props: ["data", "default"],
    data() {
        return {
            selected_data: this.default ?? "",
        };
    },
    methods: {},
};
</script>
